import { BaseTransform } from './BaseTransform.js';

export class RegexTransform extends BaseTransform {
	execute(queryResponse: any): any {
		let response: any = queryResponse;
		if (queryResponse) {
			const { regexTransformOptions } = this.options;
			if (regexTransformOptions) {
				const { pattern, flags, index } = regexTransformOptions;
				try {
					const regex = new RegExp(pattern, flags);
					const result = regex.exec(response);
					if (typeof index === 'number' && result?.length > index) {
						response = result[index];
					} else {
						response = result;
					}
				} catch (ex) {
					console.error('RegexTransform: ', ex.message);
				}
			}
		}
		return response;
	}
}
